import { getAPIURL } from '../../GlobalComponents/URLs'
import { AddContactPayload, PACustomerContactView, PACustomerContactViewRow } from './customerSlice'

const useMocks = false

let mockCustomerShipTo: CustomerShipToView = [
    {
        AccountCode: '1DKCLSTX',
        AvailabilityMode: 'A', // not needed?
        QuoteAttachmentFormats: 'A', // not needed?
        ShipToID: 1,
        ShipToName: 'DK Controlssssssssssssssssssssssssssssssssssssssssssssssss sssssssssssss',
        ShipToAddress1:
            '3680 W. Royal Laneeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
    },
    {
        AccountCode: '1DKCLSTX',
        AvailabilityMode: 'A', // not needed?
        QuoteAttachmentFormats: 'A', // not needed?
        ShipToID: 2,
        ShipToName: 'DK Controls',
        ShipToAddress1: '123 Main Street',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
    },
]
export const mockAccount: PACustomerContactViewRow = {
    AccountCode: '1DKCLSTX',
    EmailAddress: 'a@a.com',
    ShipToName: 'DK Controlsssssssssssssssssssssssssssssssssssssssssssssssssssss',
    ShipToAddress1:
        '3680 W. Royal Laneeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    ShipToAddress2: 'Suite 175',
    ShipToCity: 'Irving',
    ShipToState: 'TX',
    ShipToCountry: 'United States',
    ShipToZipcode: '75063',
    BillToName: 'DK Controls LLC',
    BillToAddress1: '3680 W. Royal Lane',
    BillToAddress2: 'Suite 175',
    BillToCity: 'Irving',
    BillToState: 'TX',
    BillToCountry: 'United States',
    BillToZipcode: '75063',
    LastTransaction: new Date().toISOString(),
    Terms: 'Standard', // Identifier fied?
    ParentAccountCode: '1DKCLSTX',
    ExactMatch: true,
    CreditLimit: 3000,
    ARBalance: 3000,
}
mockCustomerShipTo = [...mockCustomerShipTo, ...mockCustomerShipTo, ...mockCustomerShipTo]
mockCustomerShipTo = [...mockCustomerShipTo, ...mockCustomerShipTo, ...mockCustomerShipTo]
mockCustomerShipTo = [...mockCustomerShipTo, ...mockCustomerShipTo, ...mockCustomerShipTo]
let mockCustomerList: PACustomerContactView = [
    {
        AccountCode: '1DKCLSTX',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls',
        ShipToAddress1: '3680 W. Royal Lane',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '3680 W. Royal Lane',
        BillToAddress2: 'Suite 175',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
        ReasonName: 'Uncertain',
    },
    {
        AccountCode: '1DKCOMB',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls LLC',
        ShipToAddress1: '6641 N. Beltine Rd',
        ShipToAddress2: 'Suite 120',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '6641 N. Beltine Rd',
        BillToAddress2: 'Suite 120',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCLSTX',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls',
        ShipToAddress1: '3680 W. Royal Lane',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '3680 W. Royal Lane',
        BillToAddress2: 'Suite 175',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCOMB',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls LLC',
        ShipToAddress1: '6641 N. Beltine Rd',
        ShipToAddress2: 'Suite 120',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '6641 N. Beltine Rd',
        BillToAddress2: 'Suite 120',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCLSTX',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls',
        ShipToAddress1: '3680 W. Royal Lane',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '3680 W. Royal Lane',
        BillToAddress2: 'Suite 175',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCOMB',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls LLC',
        ShipToAddress1: '6641 N. Beltine Rd',
        ShipToAddress2: 'Suite 120',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '6641 N. Beltine Rd',
        BillToAddress2: 'Suite 120',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCLSTX',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls',
        ShipToAddress1: '3680 W. Royal Lane',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '3680 W. Royal Lane',
        BillToAddress2: 'Suite 175',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCOMB',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls LLC',
        ShipToAddress1: '6641 N. Beltine Rd',
        ShipToAddress2: 'Suite 120',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '6641 N. Beltine Rd',
        BillToAddress2: 'Suite 120',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCLSTX',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls',
        ShipToAddress1: '3680 W. Royal Lane',
        ShipToAddress2: 'Suite 175',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '3680 W. Royal Lane',
        BillToAddress2: 'Suite 175',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
    {
        AccountCode: '1DKCOMB',
        EmailAddress: 'a@a.com',
        ShipToName: 'DK Controls LLC',
        ShipToAddress1: '6641 N. Beltine Rd',
        ShipToAddress2: 'Suite 120',
        ShipToCity: 'Irving',
        ShipToState: 'TX',
        ShipToCountry: 'United States',
        ShipToZipcode: '75063',
        BillToName: 'DK Controls LLC',
        BillToAddress1: '6641 N. Beltine Rd',
        BillToAddress2: 'Suite 120',
        BillToCity: 'Irving',
        BillToState: 'TX',
        BillToCountry: 'United States',
        BillToZipcode: '75063',
        LastTransaction: new Date().toISOString(),
        Terms: 'Standard', // Identifier fied?
        ParentAccountCode: '1DKCLSTX',
        ExactMatch: true,
    },
]

let mockRecipients: ContactCustomerAccountCodeView = [
    {
        EmailAddress: 'carlsmith@dkcontrols.net',
        FirstName: 'Carl',
        LastName: 'Smith',
        CustomerAccountCode: '1DKCLSTX',
        ContactKey: 1,
        Prospect: false,
        ContactCompanyName: '1DKCLSTX',
    },
    {
        EmailAddress: 'carlsmith@dkcontrols.net',
        FirstName: 'Carl',
        LastName: 'Smith',
        CustomerAccountCode: '1DKCLSTX',
        ContactKey: 1,
        Prospect: false,
        ContactCompanyName: '1DKCLSTX',
    },
    {
        EmailAddress: 'carlsmith@dkcontrols.net',
        FirstName: 'Carl',
        LastName: 'Smith',
        CustomerAccountCode: '1DKCLSTX',
        ContactKey: 1,
        Prospect: false,
        ContactCompanyName: '1DKCLSTX',
    },
    {
        EmailAddress: 'carlsmith@dkcontrols.net',
        FirstName: 'Carl',
        LastName: 'Smith',
        CustomerAccountCode: '1DKCLSTX',
        ContactKey: 1,
        Prospect: false,
        ContactCompanyName: '1DKCLSTX',
    },
]
export interface Contact {
    Email: string
    FirstName: string
    LastName: string
}
mockRecipients = [...mockRecipients, ...mockRecipients, ...mockRecipients]
mockRecipients = [...mockRecipients, ...mockRecipients, ...mockRecipients]
mockRecipients = mockRecipients.map((row, i) => ({
    ...row,
    EmailAddress: row.EmailAddress! + i,
    FirstName: row.FirstName + i,
    LastName: row.LastName + i,
}))

export const mockCustomers = mockRecipients
export async function fetchCustomer(accountCode: string): Promise<CustomerRow> {
    let url = getAPIURL() + 'customer/getCustomer'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            accountCode,
        }),
    })
    let json: CustomerRow[] = await req.json()
    return await json[0]
}

export interface CustomerIDInfoRow {
    EntityName: string
    UniqueCustomerName: string
}
export async function fetchCustomerIdInfo(UniqueCustomerId: number): Promise<CustomerIDInfoRow> {
    let url = getAPIURL() + 'customer/getUniqueId'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            UniqueCustomerId,
        }),
    })
    let json: CustomerIDInfoRow[] = await req.json()
    return await json[0]
}

export interface CustomerTaxCertificate {
    AccountCode: string
    CertificateID: string
    TaxID: string
    ExposureZone: string
    ExemptReason: string
    EffectiveDate: string
    ExpirationDate: string
    isValid: boolean
    CreatedDate: string
    PONumber: string
}

const customerTaxCertificatesCacheMap: Map<string, CustomerTaxCertificate[] | null> = new Map()

export const getCustomerTaxCertificateByCustomerAccountCode = async (
    customerAccountCode: string
): Promise<CustomerTaxCertificate[] | null> => {
    if (!customerTaxCertificatesCacheMap.has(customerAccountCode)) {
        const taxCerts = await fetchCustomerTaxCertificates(customerAccountCode)
        customerTaxCertificatesCacheMap.set(customerAccountCode, taxCerts)
    }

    return customerTaxCertificatesCacheMap.get(customerAccountCode)!
}

export async function fetchCustomerTaxCertificates(
    CustomerAccountCode: string
): Promise<CustomerTaxCertificate[] | null> {
    let url = getAPIURL() + 'customer/GetCustomerTaxCertificates'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            CustomerAccountCode,
        }),
    })
    if (req.status === 200) {
        let json: CustomerTaxCertificate[] = await req.json()
        return await json
    }
    return null
}

interface FetchCustomerShipTosPayload {
    CustomerShipToView: CustomerShipToView
}
interface FetchCustomersPayload {
    PACustomerContactView: PACustomerContactView
}
let searchController = new AbortController()
export const cancelSearch = () => searchController.abort()
export const fetchCustomers = async (searchValue: string): Promise<PACustomerContactView> => {
    // return []
    // return [mockCustomerList[0], mockCustomerList[1]]
    // return [mockCustomerList[0], mockCustomerList[1], mockCustomerList[2], mockCustomerList[3]]
    if (searchValue.trim() === '') return []
    if (useMocks) return mockCustomerList
    let url = getAPIURL() + 'customer/search'
    searchController = new AbortController()
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        signal: searchController.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            searchKey: searchValue,
        }),
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error('bad request ' + resp.statusText)
        })
        .catch((err) => {
            console.error('Error fetching')
        })
    let json: FetchCustomersPayload = await req
    return json.PACustomerContactView
}

export interface AddShipToPayload {
    accountCode: string
    name: string
    state: string
    city: string
    address1: string
    address2: string
    zipcode: string
    country: string
    isDefault: boolean
}
export const fetchAddShipTo = async (payload: AddShipToPayload) => {
    if (payload.accountCode.trim().length === 0) throw new Error('Account code missing')
    let url = getAPIURL() + 'customer/addShipTo'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    // if it's a conflict we're ignoring the error andd using it
    if (!(req.ok || req.status === 409)) throw new Error('Failed to create ship to address')
}
export const fetchAddContact = async (payload: AddContactPayload) => {
    if (payload.accountCode.trim().length === 0) throw new Error('Account code missing')
    let url = getAPIURL() + 'customer/addContact'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    // if it's a conflict we're ignoring the error andd using it
    if (!(req.ok || req.status === 409)) throw new Error('Failed to create ship to address')
    let contactKey = await req.json()
    return contactKey
}

export interface AddCustomerPayload {
    Customer: Array<{
        AccountCode: string
        BillToName: string
        BillToAddress1: string
        BillToAddress2: string
        BillToZipcode: string
        BillToCity: string
        BillToState: string
        BillToCountry: string
        ContactName: string
        ContactEmail: string
        ContactPhone: string
        Prospect: boolean
        FirstTransaction: Date
        CustomerReasonId: string // actually a num or empty
        CustomerType: string // actually a num or empty
        CustomerReasonQualifier: string
        InvoiceDocumentTemplate: 'InvoiceCR'
        LastUpdated: Date
        LastUpdatedBy: string
        QuoteAttachmentFormats: 'EP'
        AvailabilityMode: 'B'
        NamedCarrierServiceKey: '2;7'
        CarrierTermsKey: 4
    }>
}
export const fetchAddCustomer = async (payload: AddCustomerPayload) => {
    if (payload.Customer.length === 0 || payload.Customer[0].AccountCode.trim().length === 0)
        throw new Error('Account code missing')
    let url = getAPIURL() + 'customer/saveCustomer'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    // if it's a conflict we're ignoring the error andd using it
    if (!req.ok) throw new Error('Failed to create customer')
}

export interface SaveCustomerPayload {
    accountCode: string
    customerType: number
}

export const fetchSaveCustomer = async (payload: SaveCustomerPayload) => {
    if (!payload.accountCode || !payload.customerType)
        throw new Error('Account code or customer type missing')

    let url = getAPIURL() + 'customer/saveCustomer'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            Customer: [
                {
                    AccountCode: payload.accountCode,
                    CustomerType: payload.customerType,
                },
            ],
        }),
    })

    return req.ok
}

export interface UpdateIdentifierPayload {
    accountCode: string
    reasonId: number
    qualifier: string
}
export const fetchUpdateIdentifier = async (payload: UpdateIdentifierPayload) => {
    if (payload.accountCode.trim().length === 0) throw new Error('Account code missing')
    let url = getAPIURL() + 'customer/updateIdentifier'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (!req.ok) throw new Error('Failed to update identifier')
}

export const fetchCustomerShipTos = async (accountCode: string) => {
    // return [mockCustomerShipTo[0]]
    if (useMocks) return mockCustomerShipTo
    let url = getAPIURL() + 'customer/getShipTos'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            accountCode,
        }),
    })
    let json: FetchCustomerShipTosPayload = await req.json()

    return json.CustomerShipToView
}

export const fetchContacts = async (accountCode: string) => {
    if (useMocks) return mockRecipients
    let url = getAPIURL() + 'customer/getContacts'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            accountCode,
        }),
    })

    let json: { ContactCustomerAccountCodeView: ContactCustomerAccountCodeView } = await req.json()

    return json.ContactCustomerAccountCodeView
}
export interface PostSaveContactPayload {
    Contact: Array<
        ContactViewRow & {
            // intentionally not using the view for the type here
            ContactCustomerAccountCodeView: ContactCustomerAccountCode
        }
    >
}
export const fetchSaveContact = async (payload: PostSaveContactPayload) => {
    if (payload.Contact.length !== 1) throw new Error('bad payload')
    let url = getAPIURL() + 'contact/saveContact'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (!req.ok) throw new Error('Failed to save contact')
}

export const fetchRequirements = async (accountCode: string) => {
    let url = getAPIURL() + 'customer/getRequirements'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            accountCode,
        }),
    })

    let json: CustomerRequirements = await req.json()

    return json
}

export const fetchCustomerExists = async (accountCode: string): Promise<boolean> => {
    let url = getAPIURL() + 'customer/customerExists'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            accountCode,
        }),
    })

    let json: boolean = await req.json()

    return json
}

export const fetchGetContact = async (
    emailAddress?: string,
    ContactKey?: number
): Promise<false | ContactViewRow> => {
    let url = getAPIURL() + 'contact/getContact'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            emailAddress,
            ContactKey,
        }),
    })
    // if (ContactKey) {
    //     req = await fetch(url, {
    //         credentials: 'include',
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             emailAddress,
    //             ContactKey,
    //         }),
    //     })
    // } else {
    //     req = await fetch(url, {
    //         credentials: 'include',
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({
    //             emailAddress,
    //         }),
    //     })
    // }
    //TODO no contact should be an ok response
    if (!req.ok) return false
    let json: { Contact: ContactView } = await req.json()
    let contacts = json.Contact
    // Return row with the highest contact key
    return contacts.length > 0 ? contacts[contacts.length - 1] : false
}

export const fetchPricingTiers = async () => {
    let url = getAPIURL() + 'contract/getPricingTiers'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    })

    let json: { CustomerContractHeaderView: CustomerContractHeaderView } = await req.json()

    return json.CustomerContractHeaderView
}

export interface UpdatePricingTiersPayload {
    AccountCode: string
    ContractKeys: Array<number>
}
export const fetchUpdatePricingTiers = async (payload: UpdatePricingTiersPayload) => {
    if (payload.AccountCode.trim().length === 0) throw new Error('Account code missing')
    let url = getAPIURL() + 'contract/cpa/LinkContracts'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (!req.ok) return false
    else return true
}

export const fetchIndustryClassifications = async () => {
    let url = getAPIURL() + 'customer/industryclassifications'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })

    let json: IndustryClassificationView = await req.json()

    return json
}

export const fetchCustomerTypes = async () => {
    let url = getAPIURL() + 'customer/customertype'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })

    let json: CustomerTypeView = await req.json()

    return json
}

export interface UniqueCustomerReturnPayload {
    UniqueCustomerId: number
    CustomerEntityId: number
    EntityName?: string
    BusinessUnitName?: string
    SiteName?: string
}

export const fetchUniqueCustomer = async (accountCode: string) => {
    let url = getAPIURL() + 'customer/unique'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountCode: accountCode }),
    })
    let json: UniqueCustomerReturnPayload = await req.json()

    return json
}

export interface AutocompleteEntityReturnPayload {
    CustomerName: string
    CustomerEntityId: number
}

export const fetchAutocompleteEntity = async (searchKey: string) => {
    let url = getAPIURL() + 'customer/autocomplete/entity'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ searchKey: searchKey }),
    })

    let json: AutocompleteEntityReturnPayload[] = await req.json()

    return json
}

export interface AutocompleteBusinessUnitReturnPayload {
    BusinessUnitName: string
    CustomerBusinessUnitId: number
}

export const fetchAutocompleteBusinessUnit = async (customerEntityId: number) => {
    let url = getAPIURL() + 'customer/autocomplete/businessunit'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerEntityId: customerEntityId }),
    })

    let json: AutocompleteBusinessUnitReturnPayload[] = await req.json()

    return json
}

export interface AutocompleteSiteReturnPayload {
    SiteName: string
    CustomerSiteId: number
}

export const fetchAutocompleteSite = async (customerEntityId: number) => {
    let url = getAPIURL() + 'customer/autocomplete/site'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerEntityId: customerEntityId }),
    })

    let json: AutocompleteSiteReturnPayload[] = await req.json()

    return json
}

export interface UniqueCustomerSavePayload {
    AccountCode: string
    UniqueCustomerId: number
    EntityName: string
    BusinessUnitName?: string | null
    SiteName: string
    Notes: string
}

export interface UniqueCustomerSaveReturnPayload {
    NewCustomerName: string
}

export const fetchUniqueCustomerSave = async (payload: UniqueCustomerSavePayload) => {
    let url = getAPIURL() + 'customer/unique/save'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })

    return req
}
